import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterSingleGroupSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleGroupSelector_template";

declare var ko: any;
declare var dhtmlXCalendarObject: any;

export class backfill_template extends vnTemplate{

    public taskExecutersFilter: multipleSelector_template;
    public operationFilter: filterSingleGroupSelector_template;
    protected isDateScheduledStartPickerInitialized: boolean = false;
    protected dateScheduledStartCalendar: any = null;

    protected getTemplateHtml(): string{

        return /*html*/`
            <div class="backfill-container">
                <h2>Backfill Management</h2>
                <p class="form-text"
                   data-bind="visible: pageMessage, text: pageMessage"
                   style="margin-top: 0.75rem;"></p>
                
                <div class="sub-header">
                    <div class="w-justify">
                        <div class="w-left">
                            <div>
                                <button class="btn highlight" 
                                        type="button" 
                                        data-bind="click: openCreateBackfillModal">
                                    New Backfill Batch
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="backfill-batches">
                    <h3>Backfill Batches</h3>
                    <div class="w-list-results content_buckets taller" id="list-results">
                        <table class="list-results list-sections" id="list-results-table">
                            <thead class="sticky">
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Status</th>
                                    <th>Date Created</th>
                                    <th>Date Updated</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: batches" id="list-results-body">
                                <tr>
                                    <td data-bind="text: id"></td>
                                    <td data-bind="text: name"></td>
                                    <td>
                                        <span class="status-badge"
                                              data-bind="text: status, css: {'status-error': status === 'missing_tasks', ['status-' + status]: status !== 'missing_tasks'}"></span>
                                    </td>
                                    <td data-bind="text: dateCreated"></td>
                                    <td data-bind="text: dateUpdated || '-'"></td>
                                    <td class="backfill-actions-cell">
                                        <div class="backfill-actions">
                                            <button class="btn icon border only-icon i-view backfill-action-btn"
                                                    type="button"
                                                    title="View details"
                                                    aria-label="View details"
                                                    data-bind="click: $parent.viewBatchCompletion.bind($parent, id)"></button>
                                            <button class="btn icon border only-icon i-delete backfill-action-btn"
                                                    type="button"
                                                    title="Delete batch"
                                                    aria-label="Delete batch"
                                                    data-bind="click: $parent.deleteBatch.bind($parent, id), disable: $parent.isLoading()"></button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div id="batch-create-dialog" class="w-lightbox dark-theme"
                     data-bind="css: {'is-visible': isCreateModalOpen}">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form w-form-large backfill-create-form">
                            <div class="form-header">
                                <h3 class="form-title">Create Backfill Batch</h3>
                                <button type="button"
                                        class="close-btn icon i-close"
                                        data-bind="click: closeCreateBackfillModal"></button>
                            </div>

                            <div class="form-body full-width backfill-create-body">
                                <div class="form-group backfill-create-filter backfill-operation-filter">
                                    <label class="form-label">Operation</label>
                                    <div style="margin-top: 0.5rem;">
                                        ${this.operationFilter ? this.operationFilter.getHtmlBuild() : ''}
                                    </div>
                                </div>

                                <div class="form-group backfill-create-filter backfill-task-executers-filter">
                                    <label class="form-label">Task Executers</label>
                                    <div style="margin-top: 0.5rem;">
                                        ${this.taskExecutersFilter ? this.taskExecutersFilter.getHtmlBuild() : ''}
                                    </div>
                                    <div class="backfill-task-executers-loading"
                                         data-bind="visible: isTaskExecutersLoading">
                                        <span class="backfill-task-executers-loading-spinner"></span>
                                        <span class="backfill-task-executers-loading-text">Loading task executers...</span>
                                    </div>
                                    <p class="form-note backfill-task-executers-info"
                                       data-bind="visible: taskExecutersInfoMessage() && !isTaskExecutersLoading(), text: taskExecutersInfoMessage"></p>
                                </div>

                                <div class="w-filters-selected" style="min-width: auto; margin-top: 0.5rem;">
                                    <div id="selected-task-executers"></div>
                                </div>

                                <div class="form-group" style="margin-top: 1.5rem;">
                                    <label class="form-label" for="dates-input">Dates (YYYY-MM-DD, one per line)</label>
                                    <textarea id="dates-input"
                                              class="input-text"
                                              rows="5"
                                              placeholder="2026-02-01&#10;2026-02-02&#10;2026-02-03"
                                              style="height: 14rem;"
                                              data-bind="value: datesInput"></textarea>
                                </div>

                                <div class="form-group" style="margin-top: 1.5rem;">
                                    <label class="form-label" for="priority-input">Priority (optional)</label>
                                    <input id="priority-input"
                                           class="input-text"
                                           type="number"
                                           min="0"
                                           placeholder="Lower runs first"
                                           data-bind="value: priorityInput" />
                                </div>

                                <div class="form-group backfill-start-scheduled" style="margin-top: 1rem;">
                                    <label class="form-label">First Date Scheduled At (optional)</label>
                                    <div class="w-date-picker single">
                                        <div class="date-picker icon i-calendar">
                                            <input type="text"
                                                   readonly
                                                   data-bind="value: dateScheduledStartInput, attr: { id: dateScheduledStartPickerId }">
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group" style="margin-top: 1rem;">
                                    <label class="form-label" for="scheduled-interval-input">Date Scheduled Interval Minutes (optional)</label>
                                    <input id="scheduled-interval-input"
                                           class="input-text"
                                           type="number"
                                           min="0"
                                           placeholder="Leave empty for +1s per date"
                                           data-bind="value: dateScheduledIntervalMinutesInput" />
                                </div>

                                <div class="form-group" style="margin-top: 1rem;">
                                    <label class="form-label" for="extra-info-input">Extra Info (optional)</label>
                                    <textarea id="extra-info-input"
                                              class="input-text"
                                              rows="3"
                                              placeholder='Ex: {"source":"manual_backfill","note":"investigation"}'
                                              data-bind="value: extraInfoInput"></textarea>
                                </div>

                                <div class="form-group" style="margin-top: 1rem;">
                                    <p class="form-note">
                                        Scheduling: first date runs at your start datetime (or now + 5 minutes if empty). For each next date, we add your interval in minutes.
                                        If interval is empty or 0, we apply +1 second per date to preserve date order.
                                    </p>
                                </div>
                            </div>

                            <div class="form-footer">
                                <button class="btn"
                                        type="button"
                                        data-bind="click: closeCreateBackfillModal">
                                    Cancel
                                </button>
                                <button class="btn highlight"
                                        type="button"
                                        data-bind="click: onSubmitBackfill, disable: isLoading()">
                                    Create Backfill Batch
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="batch-completion-dialog" class="w-lightbox dark-theme"
                     data-bind="css: {'is-visible': isCompletionModalOpen}">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form backfill-completion-form">
                            <div class="form-header">
                                <h3 class="form-title">Batch Details</h3>
                                <button type="button"
                                        class="close-btn icon i-close"
                                        data-bind="click: closeBatchCompletionModal"></button>
                            </div>

                            <div class="form-body">
                                <div class="form-group" data-bind="visible: isCompletionLoading">
                                    <p class="form-text">Loading batch details...</p>
                                </div>

                                <div class="form-group" data-bind="visible: completionError">
                                    <p class="form-text" data-bind="text: completionError"></p>
                                </div>

                                <div class="form-group" data-bind="if: completionDetails">
                                    <p class="form-text">
                                        <strong>ID:</strong>
                                        <span data-bind="text: completionDetails().batchId"></span>
                                    </p>
                                    <p class="form-text">
                                        <strong>Name:</strong>
                                        <span style="display:block; overflow-wrap:anywhere; word-break:break-word;"
                                              data-bind="text: completionDetails().batchName"></span>
                                    </p>
                                    <p class="form-text">
                                        <strong>Status:</strong>
                                        <span data-bind="text: completionDetails().status"></span>
                                    </p>
                                    <p class="form-text">
                                        <strong>Progress:</strong>
                                        <span data-bind="text: completionDetails().doneTasks"></span>
                                        /
                                        <span data-bind="text: completionDetails().totalTasks"></span>
                                        (
                                        <span data-bind="text: completionDetails().percentage"></span>
                                        %)
                                    </p>
                                    <p class="form-text">
                                        <strong>Pending Tasks:</strong>
                                        <span data-bind="text: completionDetails().pendingTasks"></span>
                                    </p>
                                </div>

                                <div class="form-group" data-bind="if: completionDetails">
                                    <h4 class="form-label" style="margin-bottom: 0.5rem;">Tasks</h4>

                                    <p class="form-text"
                                       data-bind="visible: completionTasksError, text: completionTasksError"></p>

                                    <div data-bind="visible: completionTasks().length > 0">
                                        <div class="backfill-completion-table-wrap">
                                            <div class="backfill-completion-loading-overlay"
                                                 data-bind="visible: isCompletionTasksLoading"></div>
                                            <table class="w-table">
                                                <thead>
                                                <tr>
                                                    <th>Task ID</th>
                                                    <th>System</th>
                                                    <th>Brand</th>
                                                    <th>Date Op</th>
                                                    <th>Scheduled</th>
                                                    <th>Status</th>
                                                    <th>Priority</th>
                                                    <th>Errors</th>
                                                    <th>Extra Info</th>
                                                </tr>
                                                </thead>
                                                <tbody data-bind="foreach: completionTasks">
                                                <tr data-bind="css: {'backfill-now-divider': hasNowDivider === true}">
                                                    <td data-bind="text: taskId"></td>
                                                    <td data-bind="text: systemName"></td>
                                                    <td data-bind="text: brandShortName || '-'"></td>
                                                    <td data-bind="text: dateOperation || '-'"></td>
                                                    <td data-bind="text: dateScheduled || '-'"></td>
                                                    <td data-bind="text: status"></td>
                                                    <td data-bind="text: priority !== null ? priority : '-'"></td>
                                                    <td data-bind="text: nbErrors !== null ? nbErrors : '-'"></td>
                                                    <td data-bind="text: extraInfo !== null ? extraInfo : '-'"></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div class="w-justify backfill-completion-pagination">
                                            <div class="w-left">
                                                <p class="form-text" style="margin: 0;">
                                                    Page <span data-bind="text: completionTasksPage"></span>
                                                    /
                                                    <span data-bind="text: completionTasksTotalPages"></span>
                                                    (<span data-bind="text: completionTasksTotalTasks"></span> tasks)
                                                </p>
                                            </div>
                                            <div class="w-right">
                                                <button class="btn"
                                                        type="button"
                                                        data-bind="click: loadPreviousCompletionTasksPage, enable: canLoadPreviousCompletionTasksPage()">
                                                    Previous
                                                </button>
                                                <button class="btn"
                                                        type="button"
                                                        data-bind="click: loadNextCompletionTasksPage, enable: canLoadNextCompletionTasksPage()">
                                                    Next
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <p class="form-text"
                                       data-bind="visible: !isCompletionTasksLoading() && !completionTasksError() && completionTasks().length === 0">
                                        No tasks found for this batch.
                                    </p>
                                </div>
                            </div>

                            <div class="form-footer">
                                <button class="btn"
                                        type="button"
                                        data-bind="click: closeBatchCompletionModal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <style>
                    #batch-create-dialog {
                        overflow-y: auto;
                    }

                    .backfill-batches .backfill-actions {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 0.35rem;
                    }

                    .backfill-batches .status-badge.status-error:before {
                        font-size: 1.2rem;
                        margin-right: 0.35rem;
                    }

                    .backfill-batches .backfill-actions-cell {
                        width: 7rem;
                        min-width: 7rem;
                    }

                    .backfill-batches .backfill-action-btn {
                        width: 2rem;
                        height: 2rem;
                        min-width: 2rem;
                        min-height: 2rem;
                        padding: 0;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                    }

                    #batch-create-dialog .lightbox-content {
                        position: relative;
                        top: auto;
                        left: auto;
                        transform: none;
                        width: min(72rem, calc(100vw - 2rem));
                        margin: 1rem auto;
                    }

                    #batch-create-dialog .backfill-create-form {
                        width: 100%;
                        min-width: 0;
                        margin: 0;
                        display: flex;
                        flex-direction: column;
                        max-height: calc(100vh - 2rem);
                    }

                    #batch-create-dialog .backfill-create-body {
                        padding: 2rem;
                        overflow-y: auto;
                        flex: 1 1 auto;
                    }

                    #batch-create-dialog .backfill-create-form .form-header,
                    #batch-create-dialog .backfill-create-form .form-footer {
                        flex: 0 0 auto;
                    }

                    #batch-create-dialog .backfill-create-filter .dropdown .dropdown-toggle {
                        border: 1px solid #d2d8e0;
                        background-image: url('/assets/images/multi-bg.svg');
                        background-size: 40px 40px;
                        background-position: center right;
                        background-repeat: no-repeat;
                        background-color: #ffffff;
                        color: #41526a;
                        font-size: 1.2rem;
                        font-weight: 700;
                        height: 4rem;
                        min-width: 19rem;
                        text-align: left;
                        padding: 0 3rem 0 1rem;
                        box-sizing: border-box;
                    }

                    #batch-create-dialog .backfill-create-filter .dropdown.select-single .dropdown-toggle {
                        background-image: url('/assets/images/dropdown-bg.svg');
                        padding: 1.5rem 3rem 0 1rem;
                    }

                    #batch-create-dialog .backfill-create-filter .dropdown .dropdown-list {
                        left: 0;
                        min-width: 12.25rem;
                        background-color: #ffffff;
                    }

                    #batch-create-dialog .backfill-operation-filter .dropdown .dropdown-toggle {
                        width: min(52rem, calc(100vw - 8rem));
                        min-width: min(52rem, calc(100vw - 8rem));
                    }

                    #batch-create-dialog .backfill-operation-filter .dropdown .dropdown-list {
                        width: min(52rem, calc(100vw - 8rem));
                        min-width: min(52rem, calc(100vw - 8rem));
                    }

                    #batch-create-dialog .backfill-operation-filter .w-multi-dropdown {
                        width: min(52rem, calc(100vw - 8rem));
                    }

                    #batch-create-dialog .backfill-operation-filter .dropdown .dropdown-list .search-list input {
                        width: 100%;
                        box-sizing: border-box;
                    }

                    #batch-create-dialog .backfill-task-executers-filter .dropdown .dropdown-toggle {
                        width: min(52rem, calc(100vw - 8rem));
                        min-width: min(52rem, calc(100vw - 8rem));
                    }

                    #batch-create-dialog .backfill-task-executers-filter .dropdown .dropdown-list {
                        width: min(52rem, calc(100vw - 8rem));
                        min-width: min(52rem, calc(100vw - 8rem));
                    }

                    #batch-create-dialog .backfill-task-executers-filter .w-multi-dropdown {
                        width: min(52rem, calc(100vw - 8rem));
                    }

                    /* Multi-level selector default top padding assumes two header rows (10rem).
                       Backfill task executers disables search, so only one header row is visible. */
                    #batch-create-dialog .backfill-task-executers-filter .w-multi-dropdown .multi-dropdown-body.is-multi {
                        padding-top: 6rem;
                    }

                    #batch-create-dialog .backfill-task-executers-filter .dropdown .dropdown-list .search-list input {
                        width: 100%;
                        box-sizing: border-box;
                    }

                    #batch-create-dialog .backfill-task-executers-info {
                        margin-top: 0.5rem;
                        text-align: left;
                        color: #c43b3b;
                    }

                    #batch-create-dialog .backfill-task-executers-loading {
                        margin-top: 0.5rem;
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                        text-align: left;
                    }

                    #batch-create-dialog .backfill-task-executers-loading-spinner {
                        width: 1.4rem;
                        height: 1.4rem;
                        display: inline-block;
                        background-image: url('/assets/images/loading.svg');
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: contain;
                    }

                    #batch-create-dialog .backfill-task-executers-loading-text {
                        color: #41526a;
                        font-size: 1.2rem;
                    }

                    #batch-create-dialog .backfill-create-filter .dropdown .dropdown-list li,
                    #batch-create-dialog .backfill-create-filter .dropdown .dropdown-list li a {
                        background-color: #ffffff;
                        color: #41526a;
                    }

                    #batch-create-dialog .backfill-create-filter .dropdown .dropdown-list li:hover,
                    #batch-create-dialog .backfill-create-filter .dropdown .dropdown-list li a:hover {
                        background-color: #f3f7fb;
                    }

                    #batch-create-dialog .backfill-create-filter .w-multi-dropdown,
                    #batch-create-dialog .backfill-create-filter .multi-dropdown-body {
                        background-color: #ffffff;
                    }

                    #batch-create-dialog .backfill-start-scheduled .w-date-picker .date-picker {
                        width: min(22rem, calc(100vw - 8rem));
                    }

                    body.backfill-create-modal-open .dhtmlxcalendar_material {
                        z-index: 10000050 !important;
                    }

                    #batch-completion-dialog .lightbox-content {
                        width: min(112rem, calc(100vw - 1rem));
                        margin: 1rem auto;
                    }

                    #batch-completion-dialog .backfill-completion-form {
                        width: 100%;
                        min-width: 0;
                    }

                    #batch-completion-dialog .backfill-completion-table-wrap {
                        position: relative;
                        max-height: 24rem;
                        overflow: auto;
                        border: 1px solid #d2d8e0;
                        background: #ffffff;
                    }

                    #batch-completion-dialog .backfill-completion-loading-overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        z-index: 2;
                        background-color: rgba(255, 255, 255, 0.85);
                        background-image: url('/assets/images/loading.svg');
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: 3rem 3rem;
                        pointer-events: none;
                    }

                    #batch-completion-dialog .backfill-completion-table-wrap table {
                        margin-bottom: 0;
                        min-width: 100%;
                        width: max-content;
                        border-collapse: collapse;
                    }

                    #batch-completion-dialog .backfill-completion-table-wrap thead th {
                        position: sticky;
                        top: 0;
                        z-index: 1;
                        background: #f3f7fb;
                        color: #2f435f !important;
                        border-bottom: 1px solid #d2d8e0;
                    }

                    #batch-completion-dialog .backfill-completion-table-wrap th,
                    #batch-completion-dialog .backfill-completion-table-wrap td {
                        color: #2f435f !important;
                        background: #ffffff;
                        white-space: nowrap;
                        padding: 0.45rem 0.6rem;
                        border-right: 1px solid #edf1f5;
                    }

                    #batch-completion-dialog .backfill-completion-table-wrap tbody tr:nth-child(even) td {
                        background: #fbfdff;
                    }

                    #batch-completion-dialog .backfill-completion-table-wrap tbody tr.backfill-now-divider td {
                        border-bottom: 3px solid #1ea4c2 !important;
                    }

                    #batch-completion-dialog .backfill-completion-table-wrap tbody tr td:last-child,
                    #batch-completion-dialog .backfill-completion-table-wrap thead tr th:last-child {
                        border-right: none;
                    }

                    #batch-completion-dialog .backfill-completion-pagination {
                        margin-top: 0.75rem;
                    }
                </style>
            </div>
        `;
    }

    protected getTemplateName(): string{
        return "backfill-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected initPartial(): void {
        this.operationFilter = new filterSingleGroupSelector_template("operationFilter", this.getTemplateViewModel(), this.caller);
        
        this.taskExecutersFilter = new multipleSelector_template("taskExecutersFilter", this.getTemplateViewModel(), this.caller);
        this.taskExecutersFilter.setLabel("Task Executers");
        this.taskExecutersFilter.setFilterContainerClass('margin-neg');
        this.taskExecutersFilter.setTagContainerId('selected-task-executers');
        this.taskExecutersFilter.setTagContainerCaption('Selected task executers:');
        this.taskExecutersFilter.setSelectAllEnabled(true);
        this.taskExecutersFilter.setSearchEnabled(false);
    }

    protected buildViewModel(): any{
        let self = this;
        
        // Create observables
        let batches = ko.observableArray([]);
        let isCreateModalOpen = ko.observable(false);
        let isCompletionModalOpen = ko.observable(false);
        let isCompletionLoading = ko.observable(false);
        let completionError = ko.observable("");
        let completionDetails = ko.observable(null);
        let activeCompletionBatchId = ko.observable(null);
        let isCompletionTasksLoading = ko.observable(false);
        let completionTasksError = ko.observable("");
        let completionTasks = ko.observableArray([]);
        let completionTasksPage = ko.observable(1);
        let completionTasksLimit = ko.observable(50);
        let completionTasksTotalPages = ko.observable(0);
        let completionTasksTotalTasks = ko.observable(0);

        return {
            pageMessage: ko.observable(""),
            datesInput: ko.observable(""),
            priorityInput: ko.observable(""),
            dateScheduledIntervalMinutesInput: ko.observable(""),
            dateScheduledStartInput: ko.observable(""),
            extraInfoInput: ko.observable(""),
            taskExecutersInfoMessage: ko.observable(""),
            isTaskExecutersLoading: ko.observable(false),
            dateScheduledStartPickerId: ko.observable("backfill-date-scheduled-start-picker"),
            
            batches: batches,
            isLoading: ko.observable(false),
            isCreateModalOpen: isCreateModalOpen,
            isCompletionModalOpen: isCompletionModalOpen,
            isCompletionLoading: isCompletionLoading,
            completionError: completionError,
            completionDetails: completionDetails,
            isCompletionTasksLoading: isCompletionTasksLoading,
            completionTasksError: completionTasksError,
            completionTasks: completionTasks,
            completionTasksPage: completionTasksPage,
            completionTasksTotalPages: completionTasksTotalPages,
            completionTasksTotalTasks: completionTasksTotalTasks,

            // Methods
            onSubmitBackfill: function() {
                if (self.caller && self.caller.submitBackfill) {
                    self.caller.submitBackfill();
                }
            },
            deleteBatch: function(batchId: number) {
                if (self.caller && self.caller.deleteBatch) {
                    self.caller.deleteBatch(batchId);
                }
            },

            openCreateBackfillModal: function() {
                isCreateModalOpen(true);
                document.body.classList.add('backfill-create-modal-open');
                setTimeout(function() {
                    self.buildDateScheduledStartPickerCalendar();
                }, 0);
            },

            closeCreateBackfillModal: function() {
                isCreateModalOpen(false);
                document.body.classList.remove('backfill-create-modal-open');
                self.resetForm();
            },

            closeBatchCompletionModal: function() {
                isCompletionModalOpen(false);
                isCompletionLoading(false);
                isCompletionTasksLoading(false);
                activeCompletionBatchId(null);
            },

            viewBatchCompletion: function(batchId: number) {
                completionError("");
                completionDetails(null);
                completionTasks([]);
                completionTasksError("");
                completionTasksPage(1);
                completionTasksTotalPages(0);
                completionTasksTotalTasks(0);
                activeCompletionBatchId(batchId);
                isCompletionModalOpen(true);
                isCompletionLoading(true);
                isCompletionTasksLoading(true);

                if (self.caller && self.caller.loadBatchCompletion) {
                    self.caller.loadBatchCompletion(batchId);
                } else {
                    completionError('Failed to load batch details.');
                    isCompletionLoading(false);
                }

                if (self.caller && self.caller.loadBatchTasksPage) {
                    self.caller.loadBatchTasksPage(batchId, 1, completionTasksLimit());
                } else {
                    completionTasksError('Failed to load task details.');
                    isCompletionTasksLoading(false);
                }
            },

            loadPreviousCompletionTasksPage: function() {
                let batchId = activeCompletionBatchId();
                if (!batchId || !self.caller || !self.caller.loadBatchTasksPage) {
                    return;
                }
                let currentPage = completionTasksPage();
                if (currentPage > 1) {
                    self.caller.loadBatchTasksPage(batchId, currentPage - 1, completionTasksLimit());
                }
            },

            loadNextCompletionTasksPage: function() {
                let batchId = activeCompletionBatchId();
                if (!batchId || !self.caller || !self.caller.loadBatchTasksPage) {
                    return;
                }
                let currentPage = completionTasksPage();
                let totalPages = completionTasksTotalPages();
                if (totalPages > 0 && currentPage < totalPages) {
                    self.caller.loadBatchTasksPage(batchId, currentPage + 1, completionTasksLimit());
                }
            },

            canLoadPreviousCompletionTasksPage: function() {
                return !isCompletionTasksLoading() && completionTasksPage() > 1;
            },

            canLoadNextCompletionTasksPage: function() {
                let totalPages = completionTasksTotalPages();
                return !isCompletionTasksLoading() && totalPages > 0 && completionTasksPage() < totalPages;
            }
        };
    }

    public setOperations(operations: Array<any>): void {
        if (!this.operationFilter) {
            console.error('operationFilter not initialized');
            return;
        }
        // Convert operations to selector options keyed by operation name (stable cross-DB key).
        // Don't add an "all" option: backfill always requires a concrete operation.
        let options: Array<any> = [];
        if (operations && operations.length > 0) {
            options = operations.map(function(op: any) {
                return {
                    // Operation IDs can collide across DBs; name is the stable selector key.
                    id: op.name,
                    name: op.name
                };
            });
        }
        
        // Preserve current selection when still valid after options refresh.
        let currentSelected = this.operationFilter.getTemplateViewModel().selectedOption();
        
        // Set options (this temporarily disables onOptionChange)
        this.operationFilter.setOptions(options);
        
        // After setOptions, onOptionChange is re-enabled
        // If we have options, check if current selection is still valid
        if (options && options.length > 0) {
            // Check if current selection is still valid
            let currentOptionExists = currentSelected !== null && currentSelected !== 0 && options.some((op: any) => op.id === currentSelected);
            
            if (!currentOptionExists) {
                // Select first operation - this will trigger onOptionChange automatically when user interacts
                // But we need to set it manually for initial load
                let firstOption = options[0];
                this.operationFilter.getTemplateViewModel().selectedOption(firstOption.id);
                this.operationFilter.getTemplateViewModel().selectedOptionText(firstOption.name);
            } else {
                // Keep current selection, just update the text in case name changed
                let currentOp = options.find((op: any) => op.id === currentSelected);
                if (currentOp) {
                    this.operationFilter.getTemplateViewModel().selectedOptionText(currentOp.name);
                }
            }
        } else {
            this.operationFilter.getTemplateViewModel().selectedOption(null);
            this.operationFilter.getTemplateViewModel().selectedOptionText("Select Operation");
        }
    }

    public setTaskExecuters(taskExecuters: Array<any>): void {
        if (!this.taskExecutersFilter) {
            console.error('taskExecutersFilter not initialized');
            return;
        }
        // Function map:
        // Step 1 groups incoming rows by database while preserving backend group order.
        // Step 2 sorts child rows within each group for quick scanning.
        // Step 3 pushes grouped data into selector component.
        // Step 4 computes and displays informational warning about DBs with no task history.
        let vm = this.getTemplateViewModel();
        // Normalize API rows into grouped selector rows.
        // IDs keep (database:idTaskExecuter) to avoid collisions between DBs.
        let groupedTaskExecuters: {[database: string]: Array<any>} = {};
        let orderedDatabases: Array<string> = [];
        let databasesWithoutExistingTasks: {[database: string]: boolean} = {};
        // Step 1: Build grouped task executer buckets and preserve insertion order by DB.
        taskExecuters.forEach(function(te: any) {
            let taskExecuterKey = te.taskExecuter ? te.taskExecuter : te.name;
            let brandLabel = te.brandShortName ? te.brandShortName : 'main';
            let databaseLabel = te.database ? te.database : 'main';
            if (te.hasExistingTasksForOperation === false) {
                databasesWithoutExistingTasks[databaseLabel] = true;
            }
            let item = {
                id: databaseLabel + ':' + te.idTaskExecuter,
                name: taskExecuterKey + ' (' + databaseLabel + ')',
                brandShortName: brandLabel,
                idTaskExecuter: te.idTaskExecuter,
                database: databaseLabel
            };
            if (!groupedTaskExecuters[databaseLabel]) {
                groupedTaskExecuters[databaseLabel] = [];
                orderedDatabases.push(databaseLabel);
            }
            groupedTaskExecuters[databaseLabel].push(item);
        });

        // Keep group order as provided by backend (main + SYSTEMS order).
        // Step 2: Sort children by display name inside each DB section.
        let groups = orderedDatabases
            .map(function(database: string) {
                let items = groupedTaskExecuters[database];
                // Keep child items alphabetically sorted for quick scanning.
                items.sort(function(a: any, b: any) {
                    return String(a.name).localeCompare(String(b.name));
                });
                return {
                    name: database,
                    items: items
                };
            });

        // Step 3: Push grouped rows into multi-level selector widget.
        this.taskExecutersFilter.setMultiSectionItems(groups);

        // Step 4: Build operator hint when operation exists in a DB but has no task history yet.
        let missingTaskDatabases = Object.keys(databasesWithoutExistingTasks);
        if (missingTaskDatabases.length > 0) {
            vm.taskExecutersInfoMessage(
                'No existing tasks found for this operation in: ' + missingTaskDatabases.join(', ') + '.'
            );
        } else {
            vm.taskExecutersInfoMessage("");
        }
    }

    public setBatches(batches: Array<any>): void {
        let vm = this.getTemplateViewModel();
        if (!batches) {
            batches = [];
        }
        vm.batches(batches);
    }

    public getFormData(): any {
        let vm = this.getTemplateViewModel();
        let dates = vm.datesInput().split('\n')
            .map((d: string) => d.trim())
            .filter((d: string) => d.length > 0);
        
        let selectedIds = this.taskExecutersFilter ? this.taskExecutersFilter.getTemplateViewModel().selectedItems() : [];
        let allItems = this.taskExecutersFilter ? this.taskExecutersFilter.getItems() : [];
        
        // Submit payload only keeps data the API validates/needs.
        let selectedTaskExecuters = selectedIds.map((id: any) => {
            let item = allItems.find((t: any) => String(t.id) === String(id));
            if (item) {
                return {
                    brandShortName: item.brandShortName,
                    idTaskExecuter: item.idTaskExecuter,
                    database: item.database
                };
            }
            return null;
        }).filter((t: any) => t !== null);

        // Get selected operation from filterSingleGroupSelector
        let selectedOperationId = this.operationFilter ? this.operationFilter.getTemplateViewModel().selectedOption() : null;
        let operationOptions = this.operationFilter ? this.operationFilter.getTemplateViewModel().options() : [];
        let selectedOperation = operationOptions.find((op: any) => op.id === selectedOperationId);
        // API contract expects operation_name, not operation id.
        let operationName = selectedOperation ? selectedOperation.name : "";

        let priority: any = null;
        let rawPriority = vm.priorityInput();
        if (rawPriority !== null && rawPriority !== undefined && String(rawPriority).trim() !== "") {
            priority = String(rawPriority).trim();
        }

        let dateScheduledIntervalMinutes: any = 0;
        let rawDateScheduledIntervalMinutes = vm.dateScheduledIntervalMinutesInput();
        if (rawDateScheduledIntervalMinutes !== null
            && rawDateScheduledIntervalMinutes !== undefined
            && String(rawDateScheduledIntervalMinutes).trim() !== "") {
            dateScheduledIntervalMinutes = String(rawDateScheduledIntervalMinutes).trim();
        }

        let dateScheduledStart: any = null;
        let rawDateScheduledStart = vm.dateScheduledStartInput();
        if (rawDateScheduledStart !== null
            && rawDateScheduledStart !== undefined
            && String(rawDateScheduledStart).trim() !== "") {
            dateScheduledStart = String(rawDateScheduledStart).trim();
        }

        let extraInfo: any = null;
        let rawExtraInfo = vm.extraInfoInput();
        if (rawExtraInfo !== null
            && rawExtraInfo !== undefined
            && String(rawExtraInfo).trim() !== "") {
            extraInfo = String(rawExtraInfo).trim();
        }

        return {
            operation_name: operationName,
            taskExecuters: selectedTaskExecuters,
            dates: dates,
            priority: priority,
            dateScheduledIntervalMinutes: dateScheduledIntervalMinutes,
            dateScheduledStart: dateScheduledStart,
            extraInfo: extraInfo
        };
    }

    public resetForm(): void {
        let vm = this.getTemplateViewModel();
        // Modal reset intentionally clears both form values and transient UI state
        // (searches, tags, loading notes, selectors).
        if (this.operationFilter) {
            this.operationFilter.setSelectedOption(null);
            this.operationFilter.getTemplateViewModel().selectedOptionText("Select Operation");
            this.operationFilter.getTemplateViewModel().searchValue("");
            this.operationFilter.getTemplateViewModel().searchMatches([]);
            this.operationFilter.getTemplateViewModel().selectedGroup(0);
            this.operationFilter.getTemplateViewModel().groupMatches([]);
        }
        if (this.taskExecutersFilter) {
            this.taskExecutersFilter.getTemplateViewModel().setTags([], this.taskExecutersFilter.getItems());
            this.taskExecutersFilter.setItems([]);
            this.taskExecutersFilter.setSelectedItems([]);
        }
        vm.datesInput("");
        vm.priorityInput("");
        vm.dateScheduledIntervalMinutesInput("");
        vm.dateScheduledStartInput("");
        vm.extraInfoInput("");
        vm.taskExecutersInfoMessage("");
        vm.isTaskExecutersLoading(false);
    }

    public activateLoading(): void {
        this.getTemplateViewModel().isLoading(true);
    }

    public deactivateLoading(): void {
        this.getTemplateViewModel().isLoading(false);
    }

    public closeCreateModal(): void {
        this.getTemplateViewModel().isCreateModalOpen(false);
        document.body.classList.remove('backfill-create-modal-open');
        this.resetForm();
    }

    public clearPageMessage(): void {
        this.getTemplateViewModel().pageMessage("");
    }

    public setTaskExecutersLoading(isLoading: boolean): void {
        this.getTemplateViewModel().isTaskExecutersLoading(isLoading);
    }

    public setTaskExecutersFilterDisabled(isDisabled: boolean): void {
        if (!this.taskExecutersFilter) {
            return;
        }

        this.taskExecutersFilter.setIsDisabled(isDisabled);
    }

    public setPageMessage(message: string): void {
        this.getTemplateViewModel().pageMessage(message);
    }

    public setCompletionLoading(isLoading: boolean): void {
        this.getTemplateViewModel().isCompletionLoading(isLoading);
    }

    public setCompletionError(message: string): void {
        this.getTemplateViewModel().completionError(message);
    }

    public setCompletionDetails(details: any): void {
        this.getTemplateViewModel().completionDetails(details);
    }

    public setCompletionTasksLoading(isLoading: boolean): void {
        this.getTemplateViewModel().isCompletionTasksLoading(isLoading);
    }

    public setCompletionTasksError(message: string): void {
        this.getTemplateViewModel().completionTasksError(message);
    }

    public setCompletionTasksPage(tasks: Array<any>, page: number, totalPages: number, totalTasks: number): void {
        let vm = this.getTemplateViewModel();
        vm.completionTasks(tasks || []);
        vm.completionTasksPage(page);
        vm.completionTasksTotalPages(totalPages);
        vm.completionTasksTotalTasks(totalTasks);
    }

    public buildDateScheduledStartPickerCalendar(): void {
        if (this.isDateScheduledStartPickerInitialized) {
            return;
        }

        let vm = this.getTemplateViewModel();
        let pickerId = vm.dateScheduledStartPickerId();
        if (!pickerId) {
            return;
        }

        // Match existing report pattern: dhtmlx calendar bound to input id.
        this.dateScheduledStartCalendar = new dhtmlXCalendarObject([pickerId]);
        this.dateScheduledStartCalendar.setDateFormat("%Y-%m-%d %H:%i");
        this.dateScheduledStartCalendar.setDate(new Date());
        vm.dateScheduledStartInput("");

        let self = this;
        this.dateScheduledStartCalendar.attachEvent("onClick", function (date) {
            // Keep API-ready datetime format in the viewmodel to avoid extra parsing later.
            vm.dateScheduledStartInput(self.formatDateTimeForApi(date));
        });
        this.dateScheduledStartCalendar.attachEvent("onTimeChange", function (date) {
            vm.dateScheduledStartInput(self.formatDateTimeForApi(date));
        });

        this.isDateScheduledStartPickerInitialized = true;
    }

    protected formatDateTimeForApi(date: Date): string {
        // Keep backend format explicit to avoid locale-dependent serialization.
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();

        return year
            + '-' + this.padInteger(month, 2)
            + '-' + this.padInteger(day, 2)
            + ' ' + this.padInteger(hour, 2)
            + ':' + this.padInteger(minutes, 2)
            + ':00';
    }

    protected padInteger(number: number, size: number): string {
        let s = number + "";
        while (s.length < size) {
            s = "0" + s;
        }
        return s;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/backfill_template.ts